<accredible-two-columns-layout
  class="sign-up-container"
  *transloco="let t; read: 'sign-up'"
  backgroundImage="'/assets/images/two-columns-layout-component/layout-purple.png'">
  <div leftColumn>
    <acs-cta-panel />
  </div>
  <div rightColumn>
    @if (!isEmailSent()) {
      <accredible-navigation-back
        [text]="t('navigation.back')"
        [textColor]="'var(--color-primary-100)'" />
    }
    <accredible-top-border-card>
      @if (!isEmailSent()) {
        <form
          class="main-panel-form"
          autocomplete="on"
          [formGroup]="formGroup"
          (ngSubmit)="recaptchaSubmit()">
          <div class="header">
            <img src="/assets/images/accredible-new-logo.svg" alt="" />
            <div class="text">
              <h1 class="mat-h2" [innerHTML]="t('form.title')"></h1>
            </div>
          </div>

          <div class="row-xs form-row">
            <accredible-text-input
              dataCy="first-name"
              [formControlRef]="getFormControl(formGroup, 'firstName')"
              [label]="t('form.first_name.label')"
              requirementLabel="required">
              @if (getFormControl(formGroup, 'firstName').hasError('required')) {
                <span [innerHTML]="t('form.first_name.errors.required')"> </span>
              }
            </accredible-text-input>

            <accredible-text-input
              dataCy="last-name"
              [formControlRef]="getFormControl(formGroup, 'lastName')"
              [label]="t('form.last_name.label')"
              requirementLabel="required">
              @if (getFormControl(formGroup, 'lastName').hasError('required')) {
                <span [innerHTML]="t('form.last_name.errors.required')"></span>
              }
            </accredible-text-input>
          </div>

          <div class="row-xs form-row">
            <accredible-text-input
              type="email"
              dataCy="email"
              [formControlRef]="getFormControl(formGroup, 'email')"
              [label]="t('form.email.label')"
              autoComplete="email"
              requirementLabel="required">
              @if (getFormControl(formGroup, 'email').hasError('required')) {
                <span [innerHTML]="t('form.email.errors.required')"></span>
              }
              @if (getFormControl(formGroup, 'email').hasError('email')) {
                <span [innerHTML]="t('form.email.errors.invalid')"></span>
              }
              @if (getFormControl(formGroup, 'email').hasError('alreadyRegistered')) {
                <span [innerHTML]="t('form.email.errors.already_registered')"></span>
              }
            </accredible-text-input>
          </div>

          <div class="row-xs form-row">
            <accredible-text-input
              type="password"
              dataCy="password"
              [formControlRef]="getFormControl(formGroup, 'password')"
              [label]="t('form.password.label')"
              [autoComplete]="'new-password'"
              requirementLabel="required">
              @if (getFormControl(formGroup, 'password').hasError('required')) {
                <span [innerHTML]="t('form.password.errors.required')"></span>
              }
              @if (getFormControl(formGroup, 'password').hasError('password')) {
                <span [innerHTML]="t('form.confirm_password.errors.invalid')"></span>
              }
            </accredible-text-input>

            <accredible-text-input
              type="password"
              dataCy="confirm-password"
              [formControlRef]="getFormControl(formGroup, 'confirmPassword')"
              [label]="t('form.confirm_password.label')"
              [autoComplete]="'new-password'"
              requirementLabel="required">
              @if (getFormControl(formGroup, 'confirmPassword').hasError('required')) {
                <span [innerHTML]="t('form.confirm_password.errors.required')"></span>
              }
              @if (getFormControl(formGroup, 'confirmPassword').hasError('mustMatch')) {
                <span [innerHTML]="t('form.confirm_password.errors.must_match')"></span>
              }
            </accredible-text-input>
          </div>

          <accredible-recaptcha [isLoading]="isLoading()" (actionV2)="onActionV2($event)">
          </accredible-recaptcha>

          <accredible-button-loading
            dataCy="create-account"
            [disableBtn]="formGroup.invalid"
            [btnType]="'submit'"
            [isLoading]="isLoading()"
            [size]="'large'"
            [btnText]="t('form.create_account')">
          </accredible-button-loading>

          <div class="footer">
            <accredible-divider />
            <div class="sign-in-cta">
              {{ t('footer.title') }}
              <a [routerLink]="'/login'">
                {{ t('footer.sign_in') }}
              </a>
            </div>

            <accredible-divider />

            <acs-mini-footer></acs-mini-footer>
          </div>
        </form>
      } @else {
        <div style="text-align: center">
          <div class="header">
            <img src="/assets/images/accredible-new-logo.svg" alt="" />
            <div class="text">
              <h1
                class="mat-h2"
                [innerHTML]="t('email_sent.title')"
                style="font-weight: 400; font-size: 20px"></h1>
            </div>
          </div>
          <acs-email-sent
            [status]="'verify'"
            [subtitle]="
              t('email_sent.subtitle', { email: getFormControl(formGroup, 'email').value })
            "
            [clickActionText]="t('email_sent.resend')"
            [isLoading]="isLoading()"
            (clickAction)="resendEmail()">
          </acs-email-sent>
        </div>
      }
    </accredible-top-border-card>
  </div>
</accredible-two-columns-layout>
